import { CONTACT_PHONE_NUMBER } from '@/constants/common';
import { formatPhoneNumber } from '@/utils/phoneNumber';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';

export default function NeedAssistanceBox() {
  const phoneContactFormatted = formatPhoneNumber(CONTACT_PHONE_NUMBER);

  return (
    <Alert
      data-testid="content-box"
      icon={false}
      sx={{ backgroundColor: '#ededed' }}>
      <Box textAlign="left">
        <AlertTitle>Need Assistance?</AlertTitle>
        <Typography>
          Contact us at{' '}
          <Typography component="span" color="primary" fontWeight="bold">
            {phoneContactFormatted}{' '}
          </Typography>
          if you need help.
        </Typography>
      </Box>
    </Alert>
  );
}
